import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { StatisticalAnalysisFilterByEnum } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-filter-by/statistical-analysis-filter-by.model'
import { StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-filters-extended/statistical-analysis-view-detail-chart-filters-extended.model'
import { StatisticalAnalysisViewDetailChartTypeChartsTypes } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-type-charts/statistical-analysis-view-detail-chart-type-charts.model'
import { StatisticalAnalysisDossiersExternalInfo } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'
import { Options, SeriesOptionsType } from 'highcharts'

export interface StatisticalAnalysisViewDetailChartFiltersExternalFiltering {
    filterType: Nullable<StatisticalAnalysisFilterByEnum>
    filterId: Nullable<number>
    sidebarFilters: Nullable<StatisticalAnalysisDossiersExternalInfo>
}

export interface StatisticalAnalysisViewDetailChartFiltersAxisX {
    groupBy1: Nullable<string>
    groupBy2: Nullable<string>
}

export interface StatisticalAnalysisViewDetailChartFilters {
    yAxis: Nullable<string>
    xAxis: StatisticalAnalysisViewDetailChartFiltersAxisX
    filterByIds: Nullable<CommonPersonnelResponse[]>
    additionalFilterBy: Nullable<StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters>
    additionalFilterById: Nullable<StatisticalAnalysisSimpleListEntitiesResponseContentExtendedFilters>
    externalFiltering: StatisticalAnalysisViewDetailChartFiltersExternalFiltering
}

export interface StatisticalAnalysisViewDetailChartData {
    categories: string[]
    series: SeriesOptionsType[]
}

export interface StatisticalAnalysisViewDetailChartState {
    selectedTypeChart: StatisticalAnalysisViewDetailChartTypeChartsTypes
    chartOptions: Options
    filters: StatisticalAnalysisViewDetailChartFilters
    promiseChart: Nullable<Promise<any>>
}
export const initialStatisticalAnalysisViewDetailChartState =
    (): StatisticalAnalysisViewDetailChartState => ({
        selectedTypeChart: StatisticalAnalysisViewDetailChartTypeChartsTypes.COLUMN,
        chartOptions: {},
        filters: {
            externalFiltering: {
                filterType: null,
                filterId: null,
                sidebarFilters: null
            },
            filterByIds: [],
            additionalFilterBy: null,
            additionalFilterById: null,
            xAxis: {
                groupBy1: null,
                groupBy2: null
            },
            yAxis: null
        },
        promiseChart: null
    })
